import Typography from '../../../components/Typography/Typography'
import { Menu } from 'antd'
import { AdditionalValesMenuItems } from './constants'
import { TActualMenuProps } from '../Charts/types'
import useRouter from '../../../hooks/useRouter'
import { routes } from '../../../router'

export const AdditionalValuesMenu = ({ setVisible }: TActualMenuProps) => {
  const { push } = useRouter()
  const handleClick = (key: string) => {
    !!setVisible && setVisible(false)
    switch (key) {
      case 'manage':
        return push(routes.additionalValues)
      default:
        return
    }
  }
  return (
    <Menu className="menu-items-wrapper actual-savings-menu">
      {AdditionalValesMenuItems.map((i) => (
        <Menu.Item key={i.key} onClick={() => handleClick(i.key)}>
          <Typography.Body1>{i.label}</Typography.Body1>
        </Menu.Item>
      ))}
    </Menu>
  )
}
